import { render } from "./TransactionPromotion.vue?vue&type=template&id=dc44d802&ts=true"
import script from "./TransactionPromotion.vue?vue&type=script&lang=ts"
export * from "./TransactionPromotion.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__